<app-background-image data-state="shipping"></app-background-image>
<app-topbar></app-topbar>

<app-sidebar class="d-print-none">
    <div class="sidebar-header"></div>
    <ul class="nav flex-column navbar-nav">
        <li class="d-grid gap-2">
            <button class="btn btn-outline-primary btn-block" (click)="back()">
                <fa-icon [icon]="faBack"></fa-icon>
                <span style="padding-left: 10px">Back</span>
            </button>
        </li>
    </ul>
</app-sidebar>
<ng-container *ngIf="{ edit: showEditor } as editor">
    <div class="main-content" [ngClass]="{ 'editor-show': editor.edit }">
        <div id="occurencetype-table">
            <div class="table-container">
                <div class="main-content-header">
                    <h3>Occurence Types</h3>
                </div>
                <div>
                    <table
                        class="table table-striped table-hover"
                        *ngIf="occurenceTypeList?.length > 0"
                    >
                        <colgroup>
                            <col style="width: auto" />
                            <col style="width: 80px" />
                        </colgroup>

                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col"><!--Edit--></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let occurenceType of occurenceTypeList">
                                <td (click)="edit(occurenceType)">
                                    {{ occurenceType.name }}
                                </td>
                                <td>
                                    <button
                                        class="btn btn-sm btn-secondary float-right"
                                        type="button"
                                        (click)="edit(occurenceType)"
                                    >
                                        Edit
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div style="display: flex; margin-top: 20px">
                    <button
                        type="button"
                        (click)="add()"
                        class="btn btn-primary btn-sm"
                    >
                        Create Occurence Type...
                    </button>
                </div>
            </div>
        </div>
        <div id="occurenceType-editor">
            <form
                *ngIf="showEditor"
                class="occurenceType-details"
                [formGroup]="occurenceTypeForm"
                (ngSubmit)="save()"
            >
                <div class="card">
                    <div class="card-header">
                        <h3>{{cardHeader}}</h3>
                    </div>
                    <div class="card-body">
                        <table class="form-table">
                            <tbody>
                                <tr>
                                    <td><label for="name">Name*</label></td>
                                    <td>
                                        <input
                                            class="form-control"
                                            type="text"
                                            formControlName="name"
                                            placeholder="Enter name"
                                            name="name"
                                            id="name"
                                            title="Name"
                                            [ngClass]="{
                                                'is-invalid':
                                                    (nameControl.touched ||
                                                        nameControl.dirty) &&
                                                    !nameControl.valid,
                                                'is-valid': nameControl.valid
                                            }"
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="card-footer">
                        <div class="btn-group float-right">
                            <button
                                class="btn btn-danger"
                                type="button"
                                *ngIf="occurenceTypeSelected"
                                (click)="delete()"
                            >
                                Delete
                            </button>
                            <button class="btn btn-primary" [disabled]="!occurenceTypeForm.valid">Update</button>

                            <button
                                class="btn btn-outline-secondary"
                                (click)="cancel()"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</ng-container>
<ng-template #sortNone>
    <div style="width: 16px; height: 21px; display: inline-block"></div>
</ng-template>
